import React, { useEffect, useState } from 'react';
import CountUp from "react-countup";

export default function DynamicCounter({ data }) {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const stats = [
    {
      end: Number(data?.section4_stat1_count) || 0,
      text: data?.section4_stat1_description,
    },
    {
      end: Number(data?.section4_stat2_count) || 0,
      text: data?.section4_stat2_description,
    },
    {
      end: Number(data?.section4_stat3_count) || 0,
      text: data?.section4_stat3_description,
    },
    {
      end: Number(data?.section4_stat4_count) || 0,
      text: data?.section4_stat4_description,
    }
  ];

  if (!data) return null;

  return (
    <section className="platform-section dynamic-count" >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="heading-text">
              <h4 className="heading center-heading">{data?.section4_heading}</h4>
            </div>
          </div>
        </div>
        <div className="row">
          {stats?.map((item, index) => (
            <div className="col-6 col-md-6 col-lg-3 platform-count" key={index}>
              <div className={`platform-text ${index === stats?.length - 1 ? "last-playform" : ""}`}>
                <div className="heading">
                  <span className="stat-number">
                    {isClient ? (<CountUp start={0} end={item?.end} duration={2} />) : (item?.end)}</span>+
                </div>
                <p>{item?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}


